import {
    setCookie,
    initMenuTrigger,
    addHideScrolledMenuClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService,
    initLazyBg,
    initShow,
    initPostToc
} from './functions';


import GLightbox from 'glightbox';




//import gsap from "gsap";


const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    initShow('animUp');
    initShow('animDown');

    // init menu trigger
    initMenuTrigger();


    // add hideScrolledMenu class management based on scroll direction
    addHideScrolledMenuClass();



    //fix gallery id for slideshow ...
    addFancyboxFixForGallery('.wp-block-gallery');
    addFancyboxFixForGallery('.wp-block-image');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();

    // dwurzędowy marquee logotypów w stopce (przeciwbieżne pasy)
    initFooterBrandsMarquee();

    // spis treści na pojedynczym wpisie
    initPostToc();


}

document.addEventListener("DOMContentLoaded", mainApp, false);


// Marquee logotypów w stopce: dwa pasy jadące w przeciwnych kierunkach..
// Klonujemy zawartość każdego pasa, aby pętla była bezszwowa, i ustawiamy
// czas trwania animacji proporcjonalnie do szerokości (stała prędkość px/s).
function initFooterBrandsMarquee() {
    // na sperofi-home marquee występuje też na stronie głównej (indexC5) i w [partners_slider]
    document.querySelectorAll('.footerBrands__slider').forEach((slider) => initSingleBrandsMarquee(slider));
}

function initSingleBrandsMarquee(slider) {
    if (!slider) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const SPEED = 60; // px na sekundę
    const tracks = Array.from(slider.querySelectorAll('.footerBrands__track'));
    if (!tracks.length) return;

    // oryginalny zestaw logo każdego pasa (do resetu przy przeliczaniu)
    const originals = tracks.map((track) => Array.from(track.children));

    const cloneLogo = (node) => {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        return clone;
    };

    const build = () => {
        slider.classList.remove('is-ready');

        tracks.forEach((track, i) => {
            const original = originals[i];
            if (!original.length) return;

            // reset do oryginalnych dzieci
            track.replaceChildren(...original);

            const setWidth = track.scrollWidth;   // szerokość jednego zestawu
            const viewport = slider.offsetWidth;
            // brak ułożenia (slider ukryty / CSS jeszcze nie zastosowany) → przerwij, bez pętli
            if (setWidth <= 0 || viewport <= 0) return;

            // 1) ile kopii zestawu potrzeba, by wypełnić szerokość (twardy limit = brak zawieszenia)
            const copies = Math.min(20, Math.max(1, Math.ceil(viewport / setWidth)));
            for (let c = 1; c < copies; c++) {
                original.forEach((node) => track.appendChild(cloneLogo(node)));
            }
            const baseWidth = track.scrollWidth;

            // 2) zduplikuj blok bazowy raz (×2) dla bezszwowego -50%
            Array.from(track.children).forEach((node) => track.appendChild(cloneLogo(node)));

            // 3) tempo proporcjonalne do szerokości bloku bazowego
            track.style.setProperty('--marquee-duration', (baseWidth / SPEED) + 's');
        });

        slider.classList.add('is-ready'); // odpala animację CSS
    };

    build();

    // przelicz przy zmianie szerokości (logo zmienia rozmiar na breakpoincie 782px)
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(build, 250);
    });
}


(function ($) {
    const mainAppWithJquery = () => {

        $('.subpageHeader__goDown').click(function () {
            const scrollTarget = $(this).offset().top;
            $('html,body').animate({ 'scrollTop': scrollTarget + 'px' }, 500);
        });

        $(document).on('click', '#primary-menu .menu-item-has-children', function (e) {
            if (window.innerWidth < 1200) {
                e.stopPropagation();
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                    $(this).parent().addClass('activeParent');
                    $('.mainHeader__menuBack').addClass('show');

                    $('.mainHeader__menuHolder')[0].scrollTop = 0;
                } else {
                    $(this).removeClass('active');
                    $(this).parent().removeClass('activeParent');
                }
            }
        });

        $(document).on('click', '.mainHeader__menuBack', function () {
            $('.activeParent:last').removeClass('activeParent');
            $('#primary-menu .menu-item.active:last').removeClass('active');
            if ($('#primary-menu .menu-item.active:last').length > 0) {
                // $('.mainHeader__menuBack').html($('.menu-item.active:last').find('>a').html());
            } else {
                // $('.mainHeader__menuBack').html('');
                $('.mainHeader__menuBack').removeClass('show');
            }
        });
        $(document).on('click', '.menuTrigger', function () {
            $('.activeParent').removeClass('activeParent');
            $('#primary-menu .menu-item.active').removeClass('active');
            $('.mainHeader__menuBack').removeClass('show');

        });

        // Mega menu (desktop ≥1200px): hover na kategorii w lewej kolumnie
        // przełącza panel podkategorii + wyróżnionego produktu
        $(document).on('mouseenter focusin', '.megaMenu__cat', function () {
            if (window.innerWidth < 1200) return;
            const $panel = $(this).closest('.megaMenu');
            $panel.find('.megaMenu__cat').removeClass('isActive');
            $(this).addClass('isActive');
            const idx = String($(this).data('mega'));
            $panel.find('.megaMenu__pane').removeClass('isActive')
                .filter('[data-mega="' + idx + '"]').addClass('isActive');
        });
        // po zamknięciu panelu wróć do pierwszej kategorii
        $(document).on('mouseleave', '#primary-menu .menuItemMega', function () {
            if (window.innerWidth < 1200) return;
            const $panel = $(this).find('.megaMenu');
            $panel.find('.megaMenu__cat, .megaMenu__pane').removeClass('isActive');
            $panel.find('[data-mega="0"]').addClass('isActive');
        });


        const viewportWidth = window.innerWidth;
        $('#primary-menu  a[href*="|"]').each(function (e) {

            let url = $(this).attr('href');
            let split_url = url.split('|');
            if (viewportWidth <= 782) {
                $(this).attr('href', split_url[0]);
            } else {
                $(this).attr('href', split_url[1]);
            }
        });
        /*
                $('a[href^="#"]').on('click', function (e) {
                    e.preventDefault();
                    var target = $(this).attr('href');
                    if (target.length > 1) {
                        var targetOffset = $(target).offset().top;
                        $('html, body').animate({
                            scrollTop: targetOffset
                        }, 500);
                    }
                    return false;
                });
                */


        if (window.location.hash) {
            window.setTimeout(() => {
                var target = window.location.hash;
                if ($(target).length > 0) {
                    var targetOffset = $(target).offset().top - 140;
                    $('html, body').animate({
                        scrollTop: targetOffset
                    }, 500);
                }
            }, 500);

        }

        $('.gAtuty__menuItem').on('click', function () {
            const target = $(this).data('target');
            $('.gAtuty__menuItem').removeClass('active');
            $(this).addClass('active');
            $('.gAtuty__contentItem').removeClass('active');
            $(`.gAtuty__contentItem#${target}`).addClass('active');

        });


        // slider referencji na stronie głównej (sekcja indexC4 / [reference_slider])
        $('.rotatorText').slick({
            infinite: false,
            arrows: false,
            dots: true,
            autoplay: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 500,
            autoplaySpeed: 10000,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        //rotator and sliders
        $('.rotatorTop').each(function () {
            var $rotator = $(this);
            var $nav = $rotator.siblings('.rotatorNav');
            var $navItems = $nav.find('.rotatorNav__item');

            // bind BEFORE slick init so the 'init' event fires our handler too
            $rotator.on('init beforeChange', function (event, slick, currentSlide, nextSlide) {
                var idx = (typeof nextSlide === 'number') ? nextSlide : (slick.currentSlide || 0);
                $navItems.removeClass('active').eq(idx).addClass('active');
            });

            $rotator.slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplaySpeed: 10000,
                fade: true,
                cssEase: 'linear'
            });

            // click on a nav item -> jump to the matching slide
            $navItems.on('click', function () {
                $rotator.slick('slickGoTo', $navItems.index(this));
            });
        });




        const lightbox = GLightbox({
            selector: ".woocommerce-product-gallery__image a,.glightbox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.glightbox a",
            slideEffect: 'fade',
            loop: true,
            dragAutoSnap: true,
        });




    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);








